// Utility for DataTable (CTA logic)
import { getAgeFromDob } from "@/hooks/useFamily";
import type { MemberInfo, Member } from "@/types/member";

/**
 * Determines if a member is eligible for invite based on age (>= 18) and member type.
 * Returns false if member is a pet or under 18, true otherwise.
 */
export function canShowInviteCTA(member: MemberInfo | Member): boolean {
  // If pet, never show invite
  const memberType =
    (member as MemberInfo).memberType || (member as Member).member_type;
  const relationship =
    (member as MemberInfo).relationship || (member as Member).relationship;
  if (memberType === "p" || Number(relationship) === 6) return false;
  // Compute age from dob fields (accepts both camelCase and snake_case)
  const dobDay = (member as MemberInfo).dobDay || (member as Member).dob_day;
  const dobMonth =
    (member as MemberInfo).dobMonth || (member as Member).dob_month;
  const dobYear = (member as MemberInfo).dobYear || (member as Member).dob_year;
  const age = getAgeFromDob(dobDay, dobMonth, dobYear);
  if (age !== null && age < 18) return false;
  return true;
}
